__turbopack_context__.v({
  "image": "PhotoThumbnail-module__gJslyq__image",
  "skeleton": "PhotoThumbnail-module__gJslyq__skeleton",
  "thumbnail": "PhotoThumbnail-module__gJslyq__thumbnail",
  "videoBadge": "PhotoThumbnail-module__gJslyq__videoBadge",
});
